import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Receituários do paciente, com cache de leitura offline (via useCachedQuery).
export function usePrescriptions(patientId) {
  const url = patientId ? '/prescriptions/patient/'.concat(patientId) : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    prescriptions: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
